export enum EMatchStatuses {
  lose = 'lose',
  draw = 'draw',
  win = 'win'
}

export type TPopoverPositions =
  | 'bottomLeft'
  | 'bottomRight'
  | 'topLeft'
  | 'topRight';

export type TPoint = `${number | string}` | '-';

export type TTeam = {
  id: number;
  name: string;
};

export type TMatch = {
  id: number;
  score: string;
  status: EMatchStatuses;
  teams?: string;
};

export type TStatistic = {
  HomeTeam: TTeam[];
  AwayTeam: TTeam[];
  Id: number;
  CompetitionId: number;
  Date: string;
  HomeScore: number;
  AwayScore: number;
  CompetitionName: string;
};

export type TStatisticTable = {
  EntityId: number;
  EntityName: string;
  PointsTotal: number;
  PositionTotal: number;
  PlayedTotal: number;
};

type TStatisticCurrentMatch = {
  Id: number;
  Date: string;
  HomeTeamName: string;
  AwayTeamName: string;
  CompetitionId: number;
  CompetitionName: string;
  HomeScore: number;
  AwayScore: number;
};

export type TMatchStatisticResponse = {
  HomeTeamId: number;
  AwayTeamId: number;
  H2HMatches: TStatistic[];
  UpcomingMatchesEnt1: TStatistic[];
  UpcomingMatchesEnt2: TStatistic[];
  PlayedMatchesEnt1: TStatistic[];
  PlayedMatchesEnt2: TStatistic[];
  H2HleagueTable: TStatisticTable[];
  CurrentMatch: TStatisticCurrentMatch;
};

export type TMatchStatistic = {
  competition: {
    id: number;
    name: string;
  };

  h2h: {
    team: TTeam;
    matches: TMatch[];
    all: TPoint;
    h: TPoint;
    a: TPoint;
    it: TPoint;
    gt?: TPoint;
  }[];

  leagueResults: {
    team: TTeam;
    pos: TPoint;
    pld: TPoint;
    pts: TPoint;
    nextMatch: TPoint;
  }[];

  lastGames: {
    team: TTeam;
    matches: TMatch[];
    it: TPoint;
    gt: TPoint;
  }[];
};
